import React, { useState, useEffect } from 'react'
import { Layout, Typography, Card, Table, Button, message, Tag } from 'antd'
import { ArrowLeftOutlined, DownloadOutlined, FilterOutlined } from '@ant-design/icons'
import ExportJsonExcel from 'js-export-excel'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { PieChart, BarChart, Pie, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const { Content } = Layout
const { Title, Paragraph } = Typography

const PathogenicDetail = (props) => {
  const { run } = props.match.params
  const [data, setData] = useState([])
  const [data1, setData1] = useState([])
  const [loading, setLoading] = useState(false)
  const [pathopoiesisData, setPathopoiesisData] = useState([])
  const [pathogenicBinNum, setPathogenicBinNum] = useState(0)

  useEffect(() => {
    const fetchDetail = async () => {
      setLoading(true)
      try {
        const res = await axios.get(`/api/pathogenic/sample/${run}/detail`)
        setData(res.data.map((item, idx) => ({ ...item, key: idx })))

        const res1= await axios.get(`/api/pathogenic/sample/${run}/gene`)
        setData1(res1.data.map((item, idx) => ({ ...item, key: idx })))

        const pathoRes = await axios.get(`/api/sample/${run}/pathopoiesis`);
        
        const pathogenicBins = pathoRes.data.pathogenicBins || 0
        // 存数字用于顶部标题展示
        setPathogenicBinNum(pathogenicBins)

        setPathopoiesisData([
          { name: 'Pathogenic', value: pathoRes.data.pathogenicBins || 0 },
          { name: 'Non-Pathogenic', value: pathoRes.data.nonPathogenicBins || 0 }
        ]);

      } catch (err) {
        message.error('Failed to load pathogenic data')
      } finally {
        setLoading(false)
      }
    }
    fetchDetail()
  }, [run])

  const columns = [
    { title: 'Bin ID', dataIndex: 'bin_id', key: 'bin_id', width: 120 },
    // { title: '', dataIndex: 'ispatho', key: 'ispatho', width: 120 },
    {
      title: 'Pathogenic',
      dataIndex: 'ispatho',
      key: 'ispatho',
      width: 120,
      render: (value) => <Tag color={value ? 'success' : 'error'}>{value ? 'Yes' : 'No'}</Tag>,
    },
    { title: 'Species', dataIndex: 'species', key: 'species', width: 250, ellipsis: true,
      // render: (text, record) => (
      //   <Link to={`/species/${record.species_id}`} style={{ color: '#1677ff', fontWeight: 600 }}>{text}</Link>
      // ),
    },
    { title: 'Genus', dataIndex: 'genus', key: 'genus', width: 160, ellipsis: true },
    { title: 'Family', dataIndex: 'family', key: 'family', width: 160, ellipsis: true },
    { title: 'Order', dataIndex: 'order_taxon', key: 'order_taxon', width: 160, ellipsis: true },
    { title: 'Class', dataIndex: 'class_taxon', key: 'class_taxon', width: 140, ellipsis: true },
    { title: 'Phylum', dataIndex: 'phylum', key: 'phylum', width: 140, ellipsis: true },
    { title: 'Domain', dataIndex: 'domain', key: 'domain', width: 120, ellipsis: true },
    // { title: 'Reads Count', dataIndex: 'readsCount', key: 'readsCount', width: 130 },
    // {
    //   title: 'NCBI',
    //   dataIndex: 'ncbi_link',
    //   key: 'ncbi_link',
    //   width: 100,
    //   render: (link) => link ? <Button type="primary" size="small" onClick={() => window.open(link, '_blank')}>NCBI</Button> : null,
    // },
    // {
    //   title: 'ENA',
    //   dataIndex: 'ena_link',
    //   key: 'ena_link',
    //   width: 100,
    //   render: (link) => link ? <Button type="primary" size="small" style={{ backgroundColor: '#00b96b' }} onClick={() => window.open(link, '_blank')}>ENA</Button> : null,
    // },
  ]

  const columns1 = [
    { title: 'Gene Locus', dataIndex: 'gene_locus', key: 'gene_locus', width: 280 },
    // { title: 'Gene Product', dataIndex: 'gene_product', key: 'gene_product', width: 280, ellipsis: true },
    {
      title:'Gene Product',
      dataIndex: 'gene_product',
      key: 'gene_product',
      width: 320,
      ellipsis: true,
      filterIcon: () => <FilterOutlined style={{ fontSize: 20, color: '#1677ff', fontWeight: 'bold' }} />,
      filters: [
        { text: 'Only hypothetical protein', value: 'hypo' },
        { text: 'Exclude hypothetical protein', value: 'non_hypo' }
      ],
      filterMultiple: false,
      onFilter: (value, record) => {
        if (value === 'hypo') {
          return record.gene_product === 'hypothetical protein';
        }
        if (value === 'non_hypo') {
          return record.gene_product !== 'hypothetical protein';
        }
        return true;
      },
    },
    { title: 'Gene Weight', dataIndex: 'gene_weight', key: 'gene_weight', width: 180, render: (val) => val != null ? val.toFixed(3) : '-'},
  ]

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ padding: '24px 16px', maxWidth: 1400, margin: '0 auto' }}>

        <Card style={{ marginBottom: 20, borderRadius: 12 }} bodyStyle={{ padding: '16px 20px' }}>
          <Title level={2} style={{ margin: 0, color: '#002156', fontSize: 22 }}>
            Pathogenic Bins Detail
          </Title>
          <Paragraph style={{ marginTop: 12, marginBottom: 0, fontSize: 14 }}>
            Run: <strong style={{ color: '#1677ff' }}>{run}</strong>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            Pathogenic bins found: <strong style={{ color: '#cf1322' }}>{pathogenicBinNum}</strong>
          </Paragraph>
        </Card>

        <Card style={{ marginBottom: 20, borderRadius: 12 }}>
          <Link to="/pathogenic">
            <Button icon={<ArrowLeftOutlined />} style={{ marginBottom: 16 }}>
              Back to Pathogenic Analysis
            </Button>
          </Link>
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            // pagination={{ pageSize: 15, showTotal: (total) => `Total ${total} bins` }}
            pagination={{
              pageSize: 10,
              pageSizeOptions: [10], // 支持切换每页条数
              showSizeChanger: true, // 开启切换每页条数
              showTotal: (total) => `Total ${total} bins`
            }}
            scroll={{ x: 'max-content' }}
            bordered={false}
          />
        </Card>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
          <Button type="primary" icon={<DownloadOutlined />} onClick={() => {
            if (!data.length) { message.warning('No data to export'); return }
            const exportData = data.map(d => ({
              'Bin ID': d.bin_id || '',
              Pathogenic: d.ispatho === true ? 'Yes' : d.ispatho === false ? 'No' : '',
              Species: d.species || '',
              Genus: d.genus || '',
              Family: d.family || '',
              Order: d.order_taxon || '',
              Class: d.class_taxon || '',
              Phylum: d.phylum || '',
              Domain: d.domain || '',
              // 'Reads Count': d.readsCount || '',
              // 'NCBI Link': d.ncbi_link || '',
              // 'ENA Link': d.ena_link || '',
            }))
            const option = { fileName: 'LRMrepo_Pathogenic_' + run, datas: [{ sheetData: exportData, sheetName: 'Detail', sheetHeader: Object.keys(exportData[0]) }] }
            new ExportJsonExcel(option).saveExcel()
            message.success('Export successfully')
          }}>Export All to Excel</Button>
        </div>
        
        <Card style={{ marginBottom: 20, borderRadius: 12 }} bodyStyle={{ padding: '20px' }}>
          <h2 style={{ marginTop: 0, fontSize: 20 }}>Pathopoiesis Distribution</h2>
          <p style={{margin: '0 0 20px 0', fontSize:14, color:'#555'}}>
            Pathogenicity of high- and medium-quality bins predicted using DCiPatho
          </p>
          <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div>
              <PieChart width={300} height={300}>
                <Pie
                  data={pathopoiesisData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={false}
                  outerRadius={100}
                  innerRadius={50}
                  dataKey="value"
                >
                  {pathopoiesisData.map((entry, index) => (
                    <Cell key={`patho-cell-${index}`} fill={index === 0 ? '#FF6B6B' : '#4ECDC4'} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => [value, 'Count']} />
                <Legend />
              </PieChart>
            </div>
            <div>
              <BarChart
                width={400}
                height={300}
                data={pathopoiesisData}
                margin={{ top: 20, right: 30, left: 40, bottom: 20 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" name="Count">
                  {pathopoiesisData.map((entry, index) => (
                    <Cell key={`patho-bar-${index}`} fill={index === 0 ? '#FF6B6B' : '#4ECDC4'} />
                  ))}
                </Bar>
              </BarChart>
            </div>
          </div>
        </Card>

        <Card style={{ marginBottom: 20, borderRadius: 12 }} bodyStyle={{ padding: '20px' }}>
          <h2 style={{ marginTop: 0, fontSize: 20 }}>Key Gene Mining(Top 100)</h2>
          {data.length === 0 ? (
            <p style={{ margin: '0 0 20px 0', fontSize: 14, color: '#555' }}>
              Analysing...
            </p>
          ) : (
            <Table
              columns={columns1}
              dataSource={data1}
              loading={loading}
              // pagination={{ pageSize: 15, showTotal: (total) => `Total ${total} genes` }}
              pagination={{
                pageSize: 10,
                pageSizeOptions: [10], // 支持切换每页条数
                showSizeChanger: true, // 开启切换每页条数
                showTotal: (total) => `Total ${total} genes`
              }}
              scroll={{ x: 'max-content' }}
              bordered={false}
            />
          )}
        </Card>

      </Content>
    </Layout>
  )
}

export default PathogenicDetail
